export enum RegistrationTokenType {
  'ASSET' = 'asset',
  'ORG' = 'org',
  'ONSITE_ASSISTANT' = 'onsite_assistant',
}

export interface TooltipState {
  visible: boolean;
  message: string;
}
